var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshotDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9158_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9158_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1712 11.8975H17.085L17.9767 13.4777H19.8139C19.9117 13.4777 19.9916 13.5598 19.9916 13.6545V19.822C19.9916 19.9166 19.9099 19.9988 19.8139 19.9988H9.14519C9.0501 19.9978 8.96762 19.9184 8.96762 19.822V13.6545C8.96762 13.5572 9.04744 13.4777 9.14519 13.4777H12.101C12.3315 13.0242 12.5621 12.5715 12.7927 12.118C12.9326 11.8421 12.8554 11.8975 13.1712 11.8975ZM7.11228 20H4V16.4408H5.44477V18.5621H7.11228V20ZM4 14.4916V9.50848H5.44477V14.4916H4ZM4 7.55928V4H7.53807V5.43791H5.44477V7.55928H4ZM9.49657 4H14.5034V5.43791H9.49657V4ZM16.4619 4H20V10.4478H18.5552V5.43791H16.4619V4ZM18.8415 14.2589C19.1339 14.2589 19.3708 14.4946 19.3708 14.7857C19.3708 15.0767 19.1339 15.3124 18.8415 15.3124C18.5491 15.3124 18.3123 15.0767 18.3123 14.7857C18.3131 14.4946 18.55 14.2589 18.8415 14.2589ZM14.9456 14.8723C15.8309 14.8723 16.5495 15.5874 16.5495 16.4686C16.5495 17.3498 15.831 18.065 14.9456 18.065C14.0602 18.065 13.3416 17.3499 13.3416 16.4686C13.3416 15.5874 14.0602 14.8723 14.9456 14.8723ZM14.9456 13.8331C16.4087 13.8331 17.5946 15.0134 17.5946 16.4695C17.5946 17.9248 16.4087 19.106 14.9456 19.106C13.4834 19.106 12.2966 17.9248 12.2966 16.4695C12.2974 15.0134 13.4834 13.8331 14.9456 13.8331Z",
    fill: "white"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9158_13463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9158_13463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotDashboard);
export default __webpack_public_path__ + "static/media/screenshot-dashboard.98ac83dab523b757e3f2733253c4a3af.svg";
export { ForwardRef as ReactComponent };